import { useState, useEffect } from "react";

/**
 * Debounce a value
 * @param value will be sent back after delay timeout
 * @param delay delay to wait for
 * @returns debounce value
 */
export const useDebounce = <T>(value: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};
